import { SkeletonBox } from '@practium/ui';
import styles from './BillingCashFlowChart.module.css';

const BAR_HEIGHTS = [
	['3rem', '1rem'],
	['5rem', '0.75rem'],
	['2.5rem', '1.5rem'],
	['6.5rem', '1rem'],
	['4rem', '1.75rem'],
	['2rem', '0.5rem'],
	['5.5rem', '1.25rem'],
	['7rem', '1.5rem'],
	['3.5rem', '2rem'],
	['6rem', '0.75rem'],
	['4.5rem', '1.25rem'],
	['7.5rem', '1.25rem'],
];

const LegendSkeleton = () => (
	<div className={styles.legendItem}>
		<SkeletonBox width="0.625rem" height="0.625rem" borderRadius="0.125rem" />
		<SkeletonBox width="4rem" height="0.75rem" />
	</div>
);

export const BillingCashFlowChartSkeleton = () => (
	<div className={styles.layout}>
		<div className={styles.body}>
			<div className={styles.summary}>
				<div className={styles.balance}>
					<SkeletonBox width="5.5rem" height="0.75rem" />
					<div className={styles.skeletonValue}>
						<SkeletonBox width="100%" height="100%" />
					</div>
				</div>

				<div className={styles.totals}>
					<SkeletonBox width="8rem" height="0.8rem" />
					{Array.from({ length: 2 }, (_, index) => (
						<div key={index} className={styles.totalRow}>
							<LegendSkeleton />
							<SkeletonBox width="6rem" height="0.75rem" />
						</div>
					))}
				</div>

				<div className={styles.balance}>
					<SkeletonBox width="100%" height="0.6875rem" />
					<SkeletonBox width="80%" height="0.6875rem" />
				</div>
			</div>

			<div className={styles.chartArea}>
				<div className={`${styles.chartContainer} ${styles.skeletonBars}`}>
					{BAR_HEIGHTS.map(([inflow, outflow], index) => (
						<div key={index} className={styles.skeletonBar}>
							<SkeletonBox width="0.875rem" height={inflow} />
							<SkeletonBox width="0.875rem" height={outflow} />
						</div>
					))}
				</div>

				<div className={styles.legend}>
					<LegendSkeleton />
					<LegendSkeleton />
				</div>
			</div>
		</div>
	</div>
);
